import EventViewLeaderboards from './EventViewLeaderboards';

export default EventViewLeaderboards;
